import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import STARRED_FILTERS_QUERY, {
	type StarredFiltersContainerQuery,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/starred-filters-container/__generated__/StarredFiltersContainerQuery.graphql';
import { withGiraAggAnonSsrFix } from '../../../common/utils.tsx';

export const sidebarProjectIssuesResource = withGiraAggAnonSsrFix(
	createRelayResource<StarredFiltersContainerQuery>({
		type: 'NAVIGATION_SIDEBAR_STARRED_FILTERS',
		getQuery: (_, { tenantContext }) => ({
			parameters: STARRED_FILTERS_QUERY,
			variables: {
				cloudId: tenantContext.cloudId,
			},
			options: { fetchPolicy: 'store-and-network' },
		}),
	}),
);
